import { inject, Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SimpleAggregate } from '../models/SimpleAggregate';
import { ReportFilter } from '../models/ReportFilter';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportMetricService implements OnInit {
  http = inject(HttpClient);

  productionPerSite: SimpleAggregate[] = [];
  productionPerWave: SimpleAggregate[] = [];
  productionPerVariety: SimpleAggregate[] = [];

  totalProduction: number = 0;
  totalTransfers: number = 0;
  totalDelinted: number = 0;
  totalDelintage: number = 0;

  transferInPerSite: SimpleAggregate[] = [];
  transferOutPerSite: SimpleAggregate[] = [];
  transferInPerVariety: SimpleAggregate[] = [];
  transferOutPerVariety: SimpleAggregate[] = [];
  constructor() {}

  ngOnInit(): void {}

  getTotalProductionPerSite(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/production/per-site',
      reportFilter
    );
  }
  getTotalProductionPerWave(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/production/per-wave',
      reportFilter
    );
  }
  getTotalProductionPerVariety(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/production/per-variety',
      reportFilter
    );
  }
  getTotalProductionAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/production/total',
      reportFilter
    );
  }

  getTotalTransfersAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/transfers/total',
      reportFilter
    );
  }

  getTotalTransferInAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/transfers/in/total',
      reportFilter
    );
  }

  getTotalTransfersOutAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/transfers/out/total',
      reportFilter
    );
  }
  getTotalDelintedAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/delinted/total',
      reportFilter
    );
  }
  getTotalDelintageAllSites(reportFilter: ReportFilter): Observable<number> {
    return this.http.post<number>(
      environment.reportMetricAPI + '/delintage/total',
      reportFilter
    );
  }

  getTotalTransferInPerSite(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/transfers/in/per-site',
      reportFilter
    );
  }

  getTotalTransferOutPerSite(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/transfers/out/per-site',
      reportFilter
    );
  }

  getTotalTransferInPerVariety(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/transfers/in/per-variety',
      reportFilter
    );
  }

  getTotalTransferOutPerVariety(
    reportFilter: ReportFilter
  ): Observable<SimpleAggregate[]> {
    return this.http.post<SimpleAggregate[]>(
      environment.reportMetricAPI + '/transfers/out/per-variety',
      reportFilter
    );
  }
}
